import React from 'react';
import { ArrowRight, Star, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import { HeroSlider } from './HeroSlider';

export const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative overflow-hidden">
      {/* Hero Slider with 2 Images */}
      <HeroSlider />
      
      {/* Content Section Below Hero */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-red-50 border border-red-200 px-4 py-2 rounded-full mb-6">
            <Star className="w-4 h-4 text-red-600 fill-red-600" />
            <span className="text-red-600 font-semibold text-sm">German Car Specialists</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight">
            Expert Care for Your
            <span className="text-red-600"> German Vehicle</span>
          </h1>

          {/* Subheading */}
          <p className="text-xl text-gray-600 mb-8 leading-relaxed max-w-3xl mx-auto">
            Specialized repair and maintenance services for BMW, Mercedes-Benz, Audi, Porsche, and Volkswagen. Trust your prized vehicle to certified experts.
          </p>

          {/* Features */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10 max-w-2xl mx-auto">
            <div className="flex items-center space-x-3 bg-white rounded-lg p-4 shadow-sm">
              <CheckCircle className="w-5 h-5 text-red-600 flex-shrink-0" />
              <span className="text-gray-700">Certified Technicians</span>
            </div>
            <div className="flex items-center space-x-3 bg-white rounded-lg p-4 shadow-sm">
              <CheckCircle className="w-5 h-5 text-red-600 flex-shrink-0" />
              <span className="text-gray-700">State-of-the-Art Equipment</span>
            </div>
            <div className="flex items-center space-x-3 bg-white rounded-lg p-4 shadow-sm">
              <CheckCircle className="w-5 h-5 text-red-600 flex-shrink-0" />
              <span className="text-gray-700">Genuine Parts Available</span>
            </div>
            <div className="flex items-center space-x-3 bg-white rounded-lg p-4 shadow-sm">
              <CheckCircle className="w-5 h-5 text-red-600 flex-shrink-0" />
              <span className="text-gray-700">Warranty on All Services</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <div className="flex flex-col">
              <Button
                onClick={() => {
                  const message = "Hi Think Mechanic, I want to book a service and claim my 15% website discount!";
                  const whatsappNumber = '+971566671468';
                  const whatsappUrl = `https://wa.me/${whatsappNumber.replace(/\s/g, '')}?text=${encodeURIComponent(message)}`;
                  window.open(whatsappUrl, '_blank');
                }}
                className="bg-red-600 hover:bg-red-700 text-white px-8 py-6 rounded-lg text-lg font-semibold transition-all duration-200 shadow-lg hover:shadow-red-600/50 group"
              >
                Book your Service & Get 15% OFF
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              <p className="text-gray-600 text-sm mt-2 text-center">
                ✨ Special discount for website visitors
              </p>
            </div>
            
            {/* AC Service Special Highlight */}
            <div className="flex flex-col relative">
              {/* Promotional Badge */}
              <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 z-10">
                <span className="bg-gradient-to-r from-yellow-400 to-orange-400 text-black px-4 py-1 rounded-full text-xs font-black uppercase shadow-lg animate-pulse">
                  🔥 Hot Offer 🔥
                </span>
              </div>
              
              <Button
                onClick={() => window.location.href = '/car-ac-expert'}
                className="bg-gradient-to-r from-blue-500 via-cyan-500 to-blue-600 hover:from-blue-600 hover:via-cyan-600 hover:to-blue-700 text-white px-8 py-6 rounded-lg text-lg font-bold transition-all duration-200 shadow-xl hover:shadow-cyan-500/50 border-2 border-cyan-300 relative overflow-hidden group"
              >
                <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700"></span>
                <span className="relative flex items-center justify-center">
                  ❄️ Car AC Not Cooling? Get 20% OFF
                </span>
              </Button>
              
              <div className="bg-gradient-to-r from-cyan-50 to-blue-50 border border-cyan-200 rounded-lg px-4 py-2 mt-2">
                <p className="text-cyan-700 text-sm font-semibold text-center">
                  ⚡ AC Repair + Gas Refill from AED 179
                </p>
              </div>
            </div>
            
            <Button
              onClick={() => {
                const element = document.getElementById('services');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              variant="outline"
              className="border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white px-8 py-6 rounded-lg text-lg font-semibold transition-all duration-200"
            >
              Our Services
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
